module.exports = {"saveItem":{"header":"Love this item?","text":"Save it as a favorite, and we'll notify you if it goes on sale, if another buyer makes an offer, and more.","mobileText":"Tap to save in your favorites."},"samePdp":{"header":"Get Updated If This Item Goes on Sale","text":"Save it and we'll also notify you if similar items are newly listed."}}


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Favorites/PdpFavoriteItemCallout.json
// module id = 3410
// module chunks = 7